import React, { useEffect, useState } from "react";
import Text from "components/Text";
import RadioInput from "components/RadioInput";
import Input from "components/Input";
import { Row, Column } from "components/Layout/Grid";
import Validator from "components/Validator";
import DomainSettingService from "services/domainSetting.service";
import { IDomainSetting } from "models/DomainSetting";
import { IOccurrenceType } from './interface';

const OccurrenceType: React.FC<IOccurrenceType> = (props) => {
  const {
    protocolCategory,
    othersOccurrence,
    setOthersOccurrence,
    occurrenceType,
    setOccurrenceType,
    isEditing
  } = props;
  const [occurrenceButtonsTypes, setOccurrenceButtonsTypes] = useState(
    Array<IDomainSetting>()
  );
  const [type, setType] = useState<string>(occurrenceType || '');

  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: "TicketOccurrenceType" } },

          { enabled: { eq: true } },
        ],
      })
      .then((result: any) => {
        if (result && result.data) {
          let _occurrenceButtonTypes: Array<IDomainSetting> = result.data;

          setOccurrenceButtonsTypes(_occurrenceButtonTypes);

          if (isEditing) {
            setType(_occurrenceButtonTypes.find(x => x.value === occurrenceType)?.key || '');
          }
        }
      });

  }, []);

  useEffect(() => {
    if (!isEditing) {
      setOccurrenceType('');
      setOthersOccurrence('');
    }
  }, [protocolCategory]);

  const setTypeOccurenceFunc = (option: IDomainSetting) => {
    setOccurrenceType(option.value || '');
    setType(option.key || '');
  };

  return (
    <Row className="flex-row flex-lg-column flex-md-column">
      <Column className="mt-5 flex-1">
        <Text className="mb-2 color-blue-gray" size={12}>
          Tipo de ocorrência
        </Text>
        <Validator value={occurrenceType} name="Tipo da ocorrência" required>
          <Row className="flex-md-column">
            {occurrenceButtonsTypes.map((el, index) => (
              <Row key={index} className="w-md-100 mt-md-1 mr-4">
                <RadioInput
                  id={el.key}
                  onClick={() => setTypeOccurenceFunc(el)}
                  checked={occurrenceType === el.value}
                >
                  <Text className="color-blue-gray">{el.value}</Text>
                </RadioInput>
              </Row>
            ))}
          </Row>
        </Validator>
      </Column>

      {type === 'OTHERS' && (
        <Column className="mt-5 mt-md-3 flex-1">
          <Text className="mb-2 color-blue-gray" size={12}>
            Outros
          </Text>
          <Validator value={othersOccurrence} name="Tipo da ocorrência" required={type === 'OTHERS' && !othersOccurrence}>
            <Input
              stateName="otherOcurrence"
              value={othersOccurrence}
              className="w-100"
              type="text"
              onChange={(e: any) => setOthersOccurrence(e.target.value)}
              placeholder="Especificar"
              maxLength={255}
            />
          </Validator>
        </Column>
      )}
    </Row>
  );
};

export default OccurrenceType;
